import { useMemo } from 'react';
import _ from 'underscore';
import { prop, pick } from 'ramda';
import { useLocation } from 'react-router-dom';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

export const useGetSubscriptionActionTypes = () => {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const clientPlatform = useDeviceSelector(prop('clientPlatform'));
    const { sessionSubscriptionTypes, sessionWrapperSubscriptionTypes } = useAppSelector(pick(['sessionSubscriptionTypes', 'sessionWrapperSubscriptionTypes']));
    const disableMessageSubscriptions = searchParams.get('disableMessageSubscriptions');
    // eslint-disable-next-line no-undef
    const { isGameWrapper } = Playtech.Variables;

    return useMemo(() => {
        if (disableMessageSubscriptions === 'all') {
            return [];
        }

        if (clientPlatform === 'download') {
            return ['bonus'];
        }

        if (disableMessageSubscriptions) {
            const decodedDisableMessageSubscriptions = decodeURIComponent(disableMessageSubscriptions);

            return isGameWrapper
                ? _.difference(sessionWrapperSubscriptionTypes || [], decodedDisableMessageSubscriptions.split(','))
                : _.difference(sessionSubscriptionTypes || [], decodedDisableMessageSubscriptions.split(','));
        }

        return isGameWrapper
            ? sessionWrapperSubscriptionTypes || []
            : sessionSubscriptionTypes || [];
    }, [clientPlatform, disableMessageSubscriptions, sessionSubscriptionTypes, sessionWrapperSubscriptionTypes, isGameWrapper]);
};
